import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/** Yetki ekle/düzenle form şeması (020): nameTr/code/object zorunlu; nameEn opsiyonel. */
export const grantFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
  code: requiredText(),
  object: requiredText(),
})

export type GrantFormValues = z.infer<typeof grantFormSchema>
